import React, { ReactNode, useEffect } from 'react'
import gsap from 'gsap'

import { PagesLayoutContainer, CenterContainer } from './styles'
import TrailBackgroundSVG from '../../assets/svgs/trail-background'
import SocialHeaderMenu from '../HeadersMenu/SocialHeaderMenu'
import useAppConfig from '../../hooks/useAppConfig'
import SuperLoading from '../SuperLoading'
import FooterCircular from '../Footers/FooterCircular'

export default function PagesLayout({
  children,
  title,
  description,
}: {
  children: ReactNode
  title: string
  description: string
}) {
  const { appConfig } = useAppConfig()

  useEffect(() => {
    const getSelector =
      window.document.getElementsByClassName('box-superLoading')

    gsap.to(getSelector, {
      opacity: 0,
      duration: 0.5,
      onComplete: () => {
        gsap.to(getSelector, {
          zIndex: '-1',
          delay: 0.2,
          duration: 0.1,
        })
      },
    })
  }, [])

  return (
    <PagesLayoutContainer>
      <SuperLoading />
      <TrailBackgroundSVG />
      <SocialHeaderMenu
        appLogo={appConfig?.appConfig?.appLogo}
        appLogoDescription={appConfig?.appConfig?.appDescription}
        actionButtonLabel={appConfig?.appConfig?.appActionLabel}
        actionButtonOnClick={() => {}}
        menuList={appConfig?.appConfig?.appRoutes}
      />
      <CenterContainer>
        <div className="top-header">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        <div className="center-content">{children}</div>
      </CenterContainer>

      <FooterCircular />
    </PagesLayoutContainer>
  )
}
